import { createModuleApi } from '@wit-support/admin-client-core';
/**
 * Module API client. Base URL is injected by the shell via {@link setAdminApiBaseUrl}
 * so the module never reads `import.meta.env` directly (keeps it portable).
 */
const api = createModuleApi({ errorFormat: 'raw' });
export function setAdminApiBaseUrl(url) {
    api.setBaseUrl(url);
}
export async function listAdmins() {
    const body = await api.get('/api/admins');
    return body.admins;
}
export async function createAdmin(body) {
    return api.post('/api/admins', body);
}
export async function updateAdmin(id, body) {
    return api.patch(`/api/admins/${id}`, body);
}
export async function disableAdmin(id) {
    const r = await api.fetchRaw(`/api/admins/${id}/disable`, { method: 'POST' });
    if (!r.ok)
        throw new Error(`disable failed ${r.status}`);
}
export async function changeMyPassword(body) {
    const r = await api.fetchRaw('/api/me/password', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(body),
    });
    if (!r.ok) {
        const text = await r.text().catch(() => '');
        let parsed = {};
        try {
            parsed = text ? JSON.parse(text) : {};
        }
        catch {
            /* ignore */
        }
        throw new Error(parsed.message ?? parsed.error ?? `change password failed ${r.status}`);
    }
}
//# sourceMappingURL=api.js.map